export default {
  getDefault: function(key,defaultValue){
    return localStorage.getItem(key) || defaultValue;
  },
  get: function(key){
    return localStorage.getItem(key);
  },
  set: function(key,value){
    return localStorage.setItem(key,value);
  },
  remove:function(key){
    return localStorage.removeItem(key);
  }
}



// WEBPACK FOOTER //
// ./src/utils/storage/index.js